import { useEffect } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Goal } from "@/components/site/Goal";
import { FoundingQuestion } from "@/components/site/FoundingQuestion";
import { Building } from "@/components/site/Building";
import { Follow } from "@/components/site/Follow";
import { Preview } from "@/components/site/Preview";
import { Support } from "@/components/site/Support";
import { TipThanks } from "@/components/site/TipThanks";
import { Footer } from "@/components/site/Footer";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);
};

function App() {
  useLenis();
  return (
    <MotionConfig reducedMotion="user">
      <a href="#main" className="ph-skip">Skip to content</a>
      <div className="ph-grain" aria-hidden="true" />
      <Header />
      <main id="main">
        <Hero />
        <Marquee />
        <Goal />
        <FoundingQuestion />
        <Building />
        <Follow />
        <Preview />
        <Support />
      </main>
      <Footer />
      <TipThanks />
    </MotionConfig>
  );
}

export default App;
